define([
    "dojo/_base/declare",
    "csi/locale",
    "./AuthenticationProvider"
], function(declare,locale,AuthenticationProvider) {

    return declare(AuthenticationProvider, {
        getFieldDefinitions: function() {
            return [
                {
                    id: "Password",
                    label: locale.resource("LoginPassword"),
                    type: "password",
                    autocomplete: true
                }
            ];
        }
    });
});